import { defineStore } from 'pinia';

const store = defineStore(
  'default',
  {},
  {
    persist: {
      key: 'catshow',
      storage: localStorage,
    },
  }
);

export default store;
//
//
// Vue.use(Vuex);
//
// const debug = process.env.NODE_ENV !== 'production';
//
// const vuexPersist = new VuexPersist({
//   key: 'catshow',
//   storage: localStorage,
// });
//
// export default new Vuex.Store({
//   modules: {},
//   plugins: [vuexPersist.plugin],
//   strict: debug,
// });
